@if (form) {
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    enctype="multipart/form-data"
  >
    <div class="flex flex-row justify-between items-center flex-wrap">
      @if (id !== "new") {
        <div class="flex items-center gap-3 md:gap-4 mb-4 justify-center">
          <app-entity-avatar-init
            [img]="user?.imagePath"
            [name]="user?.name"
            [surname]="user?.surname"
          ></app-entity-avatar-init>
          <div class="flex-1 min-w-[200px]">
            <h1
              class="text-[14px] leading-tight font-semibold tracking-tight text-slate-900 break-words !m-0"
            >
              {{ user?.name }} {{ user?.surname }}
            </h1>
            <div
              class="text-[12px] text-slate-500 flex flex-wrap items-center gap-x-2 gap-y-1"
            >
              <span class="font-mono break-all">{{ user?.email }}</span>
              @if (user?.title) {
                <span class="text-slate-300 hidden sm:inline">·</span>
              }
              <span>{{ user?.title }}</span>
            </div>
          </div>
        </div>
      }
      <div class="mb-4 flex gap-2 flex-wrap">
        <button
          type="submit"
          class="w-[180px] h-[35px] flex items-center justify-center rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium border border-none"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </div>

    <div class="mb-4 max-w-md">
      <div class="text-[14px] font-medium !text-slate-700 mb-1.5">
        {{ "uploadPhoto" | transloco }}
      </div>
      <app-media-library-drop-zone
        [mediaLibraryFiles]="[userImageMediaLibraryFile!]"
        [allowImagesSelection]="true"
        [uploadOnlyPrivateFilesModeActive]="true"
        (onFileSelected)="onUserImageMediaLibraryFileSelected($event)"
        (onFileRemoved)="onUserImageMediaLibraryFileRemoved($event)"
      ></app-media-library-drop-zone>
    </div>

    <div>
      <div class="space-y-6 min-w-0">
        <section class="rounded-2xl bg-white border border-slate-200/80 p-4">
          <h3 class="text-[14px] font-semibold text-slate-900 mb-4">
            {{ "basicInfo" | transloco }}
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "name" | transloco }}</span><span class="text-red-600">*</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="name"
                type="text"
                placeholder="{{ 'name' | transloco }}"
                required
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "surname" | transloco }}</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="surname"
                type="text"
                placeholder="{{ 'surname' | transloco }}"
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>Email</span><span class="text-red-600">*</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] font-mono text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="email"
                type="email"
                placeholder="Email"
                required
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "phoneNumber" | transloco }}</span>
              </div>
              <input
                placeholder="{{ 'phoneNumber' | transloco }}"
                class="mt-1.5 w-full px-2 py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="phone"
                type="tel"
                placeholder="Phone number"
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "title" | transloco }}</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="title"
                type="text"
                placeholder="{{ 'title' | transloco }}"
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "jobRole" | transloco }}</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="jobRole"
                type="text"
                placeholder="{{ 'jobRole' | transloco }}"
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "location" | transloco }}</span>
              </div>
              <input
                class="mt-1.5 w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                formControlName="location"
                type="text"
                placeholder="{{ 'location' | transloco }}"
              />
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "birthDate" | transloco }}</span>
              </div>
              <div class="mt-1.5 relative">
                <input
                  class="w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                  formControlName="birthday"
                  type="date"
                  placeholder="{{ 'birthDate' | transloco }}"
                />
              </div>
            </div>
            <div>
              <div
                class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
              >
                <span>{{ "language" | transloco }}</span>
              </div>
              <div class="mt-1.5 relative">
                <app-datalist-select
                  id="langSelect"
                  [options]="langOptions"
                  [multiple]="false"
                  [(activeValue)]="form.value.language"
                  (activeValueChange)="updateValue('language', $event)"
                ></app-datalist-select>
              </div>
            </div>
            @if (showPasswordField) {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "password" | transloco }}</span><span class="text-red-600">*</span>
                </div>
                <div class="mt-1.5 relative">
                  <input
                    class="w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/15 focus:border-[var(--accent)]/50 ng-untouched ng-pristine ng-valid"
                    formControlName="password"
                    type="password"
                    placeholder="{{ 'password' | transloco }}"
                    required
                  />
                </div>
              </div>
            }
          </div>
        </section>
        <section class="rounded-2xl bg-white border border-slate-200/80 p-4">
          <h3 class="text-[14px] font-semibold text-slate-900 mb-4">
            {{ "managmentGroups" | transloco }}
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            @if (
              tenantOptions &&
              tenantOptions.length &&
              !generalAppData.activeUserData.tenantSet &&
              !activeTenantId
            ) {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "tenant" | transloco }}</span>
                </div>
                <div class="mt-1.5 relative !text-[14px]">
                  <div
                    class="form-group form-floating mb-3"
                    [class.is-invalid]="
                      form.get('tenantIds')?.hasError('required') &&
                      form.get('tenantIds')?.touched
                    "
                  >
                    <app-datalist-select
                      id="tenantSelect"
                      [options]="tenantOptions"
                      [multiple]="true"
                      [(activeValue)]="form.value.tenantIds"
                      (activeValueChange)="updateValue('tenantIds', $event)"
                    ></app-datalist-select>
                  </div>
                </div>
              </div>
            }
            @if (generalAppData.activeUserData.tenantSet && mode != "profile") {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "userGroups" | transloco }}</span>
                </div>
                <div class="mt-1.5 relative !text-[14px]">
                  <div
                    class="form-group form-floating mb-3"
                    [class.is-invalid]="
                      form.get('userGroupsIds')?.hasError('required') &&
                      form.get('userGroupsIds')?.touched
                    "
                  >
                    <app-datalist-select
                      id="userGroupsSelect"
                      [options]="userGroupsOptions"
                      [multiple]="true"
                      [(activeValue)]="form.value.userGroupsIds"
                      (activeValueChange)="updateValue('userGroupsIds', $event)"
                    ></app-datalist-select>
                  </div>
                </div>
              </div>
            }
            @if (isActiveTenantSet) {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "userCoaches" | transloco }}</span>
                </div>
                <div class="mt-1.5 relative !text-[14px]">
                  <div class="form-group form-floating mb-3">
                    <app-datalist-select
                      id="userCoaches"
                      [forUsers]="true"
                      [options]="userCoachOptions"
                      [multiple]="true"
                      [(activeValue)]="form.value.userCoachIds"
                      (activeValueChange)="updateValue('userCoachIds', $event)"
                    ></app-datalist-select>
                  </div>
                </div>
              </div>
            }
            @if (isActiveTenantSet) {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "userManagers" | transloco }}</span>
                </div>
                <div class="mt-1.5 relative !text-[14px]">
                  <div class="mb-3">
                    <app-datalist-select
                      id="userManagers"
                      [forUsers]="true"
                      [options]="userManagerOptions"
                      [multiple]="true"
                      [(activeValue)]="form.value.userManagerIds"
                      (activeValueChange)="
                        updateValue('userManagerIds', $event)
                      "
                    ></app-datalist-select>
                  </div>
                </div>
              </div>
            }
            @if (isActiveTenantSet) {
              <div>
                <div
                  class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium"
                >
                  <span>{{ "userMentees" | transloco }}</span>
                </div>
                <div class="mt-1.5 relative !text-[14px]">
                  <div class="mb-3">
                    <app-datalist-select
                      id="userMentees"
                      [forUsers]="true"
                      [options]="userMenteeOptions"
                      [multiple]="true"
                      [(activeValue)]="form.value.userMenteeIds"
                      (activeValueChange)="updateValue('userMenteeIds', $event)"
                    ></app-datalist-select>
                  </div>
                </div>
              </div>
            }
            <div>
              @if (authRepo.isAnyAdmin$ | async) {
                <div
                  class="form-group form-floating flex items-center !text-[14px]"
                >
                  <input
                    type="checkbox"
                    formControlName="isManager"
                    class="form-check-input m-0 me-1"
                  />
                  {{ "manager" | transloco }}
                </div>
              }
              @if (authRepo.isSuperAdmin$ | async) {
                <div
                  class="form-group form-floating flex items-center !text-[14px]"
                >
                  <input
                    type="checkbox"
                    formControlName="isPerformanceTrackingEnabled"
                    class="form-check-input m-0 me-1"
                  />
                  {{ "isPerformanceTrackingEnabled" | transloco }}
                </div>
              }
            </div>
          </div>
        </section>
        <section class="rounded-2xl bg-white border border-slate-200/80 p-4">
          <h3 class="text-[14px] font-semibold text-slate-900 mb-4">
            {{ "rolesAccess" | transloco }}
          </h3>
          <ul
            class="grid grid-cols-1 sm:grid-cols-2 gap-3 !p-0"
            formArrayName="roles"
          >
            @for (role of roleOptions; track role; let roleIndex = $index) {
              @if (
                role !== "PartnerManager" || (authRepo.isSuperAdmin$ | async)
              ) {
                <li
                  class="bg-white border border-slate-200 hover:border-[var(--primary-color)] p-3 rounded-xl shadow-sm transition flex gap-3 items-start w-full"
                >
                  <label
                    class="relative flex items-center shrink-0 mt-1 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      class="sr-only peer"
                      [formControlName]="roleIndex"
                      [attr.id]="'checkbox-' + role"
                    />

                    <div
                      class="w-7 h-4 bg-slate-200 peer-checked:bg-[var(--primary-color)] rounded-full transition-colors duration-200"
                    ></div>

                    <div
                      class="absolute left-0.5 top-0.5 w-3 h-3 bg-white rounded-full shadow-sm transition-transform duration-200"
                      [style.transform]="
                        rolesFormArray.at(roleIndex).value
                          ? 'translateX(12px)'
                          : 'translateX(0px)'
                      "
                    ></div>
                  </label>

                  <div class="flex-1 min-w-0">
                    <label
                      [attr.for]="'checkbox-' + role"
                      class="block text-[14px] font-semibold text-slate-900 cursor-pointer"
                    >
                      {{ ROLE_NAMES[role] }}
                    </label>

                    <p
                      class="text-[12px] text-slate-500 mt-0.5 leading-relaxed"
                    >
                      {{ ROLE_DESCRIPTIONS[role] | transloco }}
                    </p>
                  </div>
                </li>
              }
            }
          </ul>
        </section>
      </div>
    </div>
  </form>
}
